module.exports = __webpack_public_path__ + "landing_static/img/header-lg.c9f92f99.png";